'use client'

import * as React from 'react'

interface QuoteBlockFields {
  blockType: 'quote'
  quote: string
}

interface QuoteBlockProps {
  fields: QuoteBlockFields
}

export function QuoteBlock({ fields }: QuoteBlockProps) {
  return (
    <figure className='ui:my-8'>
      <blockquote className='ui:relative ui:text-center'>
        <span className='ui:absolute ui:-top-4 ui:-left-2 ui:font-serif ui:text-6xl ui:text-blue-20'>&ldquo;</span>
        <p className='ui:text-xl ui:font-medium ui:italic ui:text-navy-100 ui:md:text-2xl'>{fields.quote}</p>
        <span className='ui:absolute ui:-right-2 ui:-bottom-8 ui:font-serif ui:text-6xl ui:text-blue-20'>&rdquo;</span>
      </blockquote>
    </figure>
  )
}
